export default __webpack_public_path__ + "static/media/load-car.bd50b730.png";